<ng-template #loader>
  <div class="recent_searches_no_recent">
    <i class="button_spinner light-center-absolute"></i>
  </div>
</ng-template>
<ng-template #loaderSingle>
  <i class="button_spinner light-center-absolute"></i>
</ng-template>
<section>
  <div class="recent_searches_content background-container-background">
    @if (recentSearches) {
      @if (recentSearches.length) {
        <div class="recent_searches_recent">
          <a
            i18n="@@RemoveAll"
            class="remove-all"
            (click)="removeAll()"
            (keydown.enter)="removeAll()"
            role="button"
            tabindex="0"
            aria-label="Remove all recent searches"
          >
            Remove all
          </a>
          @if (!removing) {
            <ul>
              @for (item of recentSearches; track item; let i = $index) {
                <li class="recent-search-item">
                  @if (item) {
                    <!-- Flight -->
                    @if (item.serviceType === serviceType.Flight) {
                      <div class="storageItem" (click)="performRecentSearch(item)">
                        <div class="icons">
                          <i class="ico-flight input_icon" aria-hidden="true"></i>
                          <span class="visuallyhidden" i18n="@@muliCityFlight">Flight</span>
                        </div>
                        <div class="details">
                          @if (!item.searchArgs?.multiDestination?.length) {
                            <span
                              class="Title"
                              tabindex="0"
                              (keydown.enter)="performRecentSearch(item)"
                              role="button"
                              id="recent_search_{{ i }}"
                            >
                              <!-- keeping the old way as an option so that older items don't error, remove the async part in s55 -->
                              {{
                                item.searchArgs.originAirportFull
                                  ? item.searchArgs.originAirportFull +
                                    ' (' +
                                    item.searchArgs.originAirport +
                                    ')'
                                  : (item.searchArgs.originAirport | airportIata | async)
                              }}
                              -
                              {{
                                item.searchArgs.destinationAirportFull
                                  ? item.searchArgs.destinationAirportFull +
                                    ' (' +
                                    item.searchArgs.destinationAirport +
                                    ')'
                                  : (item.searchArgs.destinationAirport | airportIata | async)
                              }}
                            </span>
                            <span class="Date">
                              {{ item.searchArgs.outboundDate | sabsDate: 1 }}
                              {{
                                item.searchArgs.returnDate
                                  ? ' - ' + (item.searchArgs.returnDate | sabsDate: 1)
                                  : ''
                              }}
                            </span>
                          }
                          @if (item.searchArgs?.multiDestination?.length) {
                            <span
                              class="Title"
                              tabindex="0"
                              (keydown.enter)="performRecentSearch(item)"
                              role="button"
                              id="recent_search_{{ i }}"
                            >
                              {{ item.searchArgs.multiDestination[0].orig | airportIata | async }} -
                              {{
                                item.searchArgs.multiDestination[
                                  item.searchArgs.multiDestination.length - 1
                                ].dest
                                  | airportIata
                                  | async
                              }}
                            </span>
                            <span class="Date">
                              {{ item.searchArgs.multiDestination[0].date | sabsDate: 1 }}
                            </span>
                          }
                          <app-recent-search-travellers
                            [travellers]="item.travellers"
                          ></app-recent-search-travellers>
                        </div>
                        <div
                          class="recent-search-remove"
                          (click)="removeRecentSearchItem(item, $event)"
                          (keydown.enter)="removeRecentSearchItem(item, $event)"
                          tabindex="0"
                          role="button"
                          aria-label="Remove flight search"
                        >
                          <i class="ico-trash" aria-hidden="true"></i>
                        </div>
                      </div>
                    }
                    <!-- Rail -->
                    @if (item.serviceType === serviceType.Rail) {
                      <div class="storageItem" (click)="performRecentSearch(item)">
                        <div class="icons">
                          <i class="ico-rail input_icon" aria-hidden="true"></i>
                          <span class="visuallyhidden" i18n="@@ProfileInformation-Rail">Rail</span>
                        </div>
                        <div class="details">
                          @if (!item.searchArgs.isAirportExpress) {
                            <span
                              class="Title"
                              tabindex="0"
                              (keydown.enter)="performRecentSearch(item)"
                              role="button"
                              id="recent_search_{{ i }}"
                            >
                              {{ item.searchArgs.travellingFrom?.name }}
                              ({{
                                item.searchArgs.travellingFrom?.stationCode ||
                                  item.searchArgs.travellingFrom?.railstation?.stationCode
                              }}),
                              {{
                                item.searchArgs.travellingFrom?.locationDetails?.country ||
                                  item.searchArgs.travellingFrom?.railstation?.locationDetails
                                    ?.country
                              }}
                              -
                              {{ item.searchArgs.travellingTo?.name }}
                              ({{
                                item.searchArgs.travellingTo?.stationCode ||
                                  item.searchArgs.travellingTo?.railstation?.stationCode
                              }}),
                              {{
                                item.searchArgs.travellingTo?.locationDetails?.country ||
                                  item.searchArgs.travellingTo?.railstation.locationDetails?.country
                              }}
                            </span>
                          }
                          @if (item.searchArgs.isAirportExpress) {
                            <span
                              class="Title"
                              tabindex="0"
                              (keydown.enter)="performRecentSearch(item)"
                              role="button"
                              id="recent_search_{{ i }}"
                            >
                              {{ item.searchArgs.airportExpressStation | airportExpress }}
                            </span>
                          }
                          <span class="Date"
                            >{{
                              item.searchArgs.outboundDepartureDateTime
                                ? (item.searchArgs.outboundDepartureDateTime | sabsDate: 1)
                                : (item.searchArgs.outboundArrivalDateTime | sabsDate: 1)
                            }}
                            <!-- if return jorney  -->
                            {{
                              item.searchArgs.returnDepartureDateTime
                                ? ' - ' + (item.searchArgs.returnDepartureDateTime | sabsDate: 1)
                                : ''
                            }}
                            {{
                              item.searchArgs.returnArrivalDateTime
                                ? ' - ' + (item.searchArgs.returnArrivalDateTime | sabsDate: 1)
                                : ''
                            }}
                          </span>
                          <app-recent-search-travellers
                            [travellers]="item.travellers"
                          ></app-recent-search-travellers>
                        </div>
                        <div
                          class="recent-search-remove"
                          (click)="removeRecentSearchItem(item, $event)"
                          (keydown.enter)="removeRecentSearchItem(item, $event)"
                          tabindex="0"
                          role="button"
                          aria-label="Remove rail search"
                        >
                          <i class="ico-trash" aria-hidden="true"></i>
                        </div>
                      </div>
                    }
                    <!-- InternationalRail -->
                    @if (item.serviceType === serviceType.InternationalRail) {
                      <div class="storageItem" (click)="performRecentSearch(item)">
                        <div class="icons">
                          <i class="ico-rail input_icon" aria-hidden="true"></i>
                          <span class="visuallyhidden">International Rail</span>
                        </div>
                        <div class="details">
                          <span
                            class="Title"
                            tabindex="0"
                            (keydown.enter)="performRecentSearch(item)"
                            role="button"
                            id="recent_search_{{ i }}"
                          >
                            {{ item.searchArgs.travellingFrom?.railstation?.name }} -
                            {{ item.searchArgs.travellingTo?.railstation?.name }}
                          </span>
                          <span class="Date"
                            >{{ item.searchArgs.outboundDepartureDateTime | sabsDate: 1 }}
                            <!-- if return jorney  -->
                            @if (item.searchArgs.journeyType === irlJourneyType.ReturnJourney) {
                              <span>
                                {{
                                  ' - ' + (item.searchArgs.returnDepartureDateTime | sabsDate: 1)
                                }}
                              </span>
                            }
                          </span>
                          <app-recent-search-travellers
                            [travellers]="item.travellers"
                          ></app-recent-search-travellers>
                        </div>
                        <div
                          class="recent-search-remove"
                          (click)="removeRecentSearchItem(item, $event)"
                          (keydown.enter)="removeRecentSearchItem(item, $event)"
                          tabindex="0"
                          role="button"
                          aria-label="Remove international rail search"
                        >
                          <i class="ico-trash" aria-hidden="true"></i>
                        </div>
                      </div>
                    }
                    <!-- Hotel -->
                    @if (
                      item.serviceType === serviceType.Hotel && item.searchArgs.location_type_select
                    ) {
                      <div class="storageItem" (click)="performRecentSearch(item)">
                        <div class="icons">
                          <i class="ico-bed input_icon" aria-hidden="true"></i>
                          <span class="visuallyhidden" i18n="@@amendHotelHotel">Hotel</span>
                        </div>
                        <div class="details">
                          <div>
                            @switch (item.searchArgs.location_type_select) {
                              @case (locationTypes.Address) {
                                @if (item.searchArgs.iata) {
                                  <div>
                                    <span
                                      class="Title"
                                      tabindex="0"
                                      (keydown.enter)="performRecentSearch(item)"
                                      role="button"
                                      id="recent_search_{{ i }}"
                                      >{{
                                        item.searchArgs.cityName
                                          ? item.searchArgs.cityName +
                                            ' (' +
                                            item.searchArgs.iata +
                                            ')'
                                          : (item.searchArgs.iata | airportIata | async)
                                      }}</span
                                    >
                                  </div>
                                } @else if (item.searchArgs.trainStationCode) {
                                  <div>
                                    <span
                                      class="Title"
                                      tabindex="0"
                                      (keydown.enter)="performRecentSearch(item)"
                                      role="button"
                                      id="recent_search_{{ i }}"
                                      >{{
                                        item.searchArgs.trainStationCode
                                          | railStationNameByCode
                                          | async
                                      }}
                                      Rail Station</span
                                    >
                                  </div>
                                } @else if (
                                  !item.searchArgs.cityName && item.searchArgs.postOrZipCode
                                ) {
                                  <div>
                                    <span
                                      class="Title"
                                      tabindex="0"
                                      (keydown.enter)="performRecentSearch(item)"
                                      role="button"
                                      id="recent_search_{{ i }}"
                                      >{{ item.searchArgs.postOrZipCode }}</span
                                    >
                                  </div>
                                } @else {
                                  <div>
                                    <span
                                      class="Title"
                                      tabindex="0"
                                      (keydown.enter)="performRecentSearch(item)"
                                      role="button"
                                      id="recent_search_{{ i }}"
                                      >{{
                                        item.searchArgs.hotelName || item.searchArgs.cityName
                                      }}</span
                                    >
                                  </div>
                                }
                              }

                              @case (locationTypes.Office) {
                                <div>
                                  @if (item.searchArgs.office; as office) {
                                    <span class="Title">
                                      {{ office?.name }}
                                    </span>
                                  }
                                </div>
                              }

                              @case (locationTypes.Shortlist) {
                                <div>
                                  @if (item.searchArgs.countryCode) {
                                    <span
                                      class="Title"
                                      tabindex="0"
                                      (keydown.enter)="performRecentSearch(item)"
                                      role="button"
                                      id="recent_search_{{ i }}"
                                      >Shortlist {{ item.searchArgs.countryCode }}</span
                                    >
                                  }
                                </div>
                              }
                            }
                          </div>
                          <span class="Date"
                            >{{ item.searchArgs.startDate | sabsDate: 1 }} -
                            {{ item.searchArgs.endDate | sabsDate: 1 }}
                          </span>
                          <app-recent-search-travellers
                            [travellers]="item.travellers"
                          ></app-recent-search-travellers>
                        </div>
                        <div
                          class="recent-search-remove"
                          (click)="removeRecentSearchItem(item, $event)"
                          (keydown.enter)="removeRecentSearchItem(item, $event)"
                          tabindex="0"
                          role="button"
                          aria-label="Remove hotel search"
                        >
                          <i class="ico-trash" aria-hidden="true"></i>
                        </div>
                      </div>
                    }
                    <!-- Car -->
                    @if (item.serviceType === serviceType.Car) {
                      <div class="storageItem" (click)="performRecentSearch(item)">
                        <div class="icons">
                          <i class="ico-car input_icon" aria-hidden="true"></i>
                          <span class="visuallyhidden">Car Hire</span>
                        </div>
                        <div class="details">
                          <div
                            class="Title"
                            tabindex="0"
                            (keydown.enter)="performRecentSearch(item)"
                            role="button"
                            id="recent_search_{{ i }}"
                          >
                            @if (item.searchArgs.city) {
                              <span>
                                {{ item.searchArgs.city.pickupName }} ({{
                                  item.searchArgs.city.pickupCountryCode
                                }}) - {{ item.searchArgs.city.dropOffName }} ({{
                                  item.searchArgs.city.dropoffCountryCode
                                }})
                              </span>
                            }
                            @if (item.searchArgs.airport) {
                              <span>
                                {{
                                  item.searchArgs?.airport.pickupAirportFullName
                                    ? item.searchArgs?.airport.pickupAirportFullName +
                                      ' (' +
                                      item.searchArgs?.airport.pickupCode +
                                      ')'
                                    : (item.searchArgs?.airport.pickupCode | airportIata | async)
                                }}
                                -
                                {{
                                  item.searchArgs?.airport.dropoffAirportFullName
                                    ? item.searchArgs?.airport.dropoffAirportFullName +
                                      ' (' +
                                      item.searchArgs?.airport.dropoffCode +
                                      ')'
                                    : (item.searchArgs?.airport.dropoffCode | airportIata | async)
                                }}
                              </span>
                            }
                            @if (item.searchArgs.depot && item.searchArgs.depot.pickupVendor) {
                              <span>
                                {{ item.searchArgs.depot.pickupVendor }}
                                {{ item.searchArgs.depot.pickupAddressLines }},
                                {{ item.searchArgs.depot.pickupCityName }} -
                                {{ item.searchArgs.depot.dropoffVendor }}
                                {{ item.searchArgs.depot.dropoffAddressLines }},
                                {{ item.searchArgs.depot.dropoffCityName }}
                              </span>
                            }
                          </div>
                          <span class="Date">
                            {{ item.searchArgs.pickupDateTime | sabsDate: 1 }} -
                            {{ item.searchArgs.dropoffDateTime | sabsDate: 1 }}
                          </span>
                          <app-recent-search-travellers
                            [travellers]="item.travellers"
                          ></app-recent-search-travellers>
                        </div>
                        <div
                          class="recent-search-remove"
                          (click)="removeRecentSearchItem(item, $event)"
                          (keydown.enter)="removeRecentSearchItem(item, $event)"
                          tabindex="0"
                          role="button"
                          aria-label="Remove car hire search"
                        >
                          <i class="ico-trash" aria-hidden="true"></i>
                        </div>
                      </div>
                    }
                    <!-- OTHER TYPES -->
                    <!-- PARKING -->
                    @if (item.serviceType === serviceType.Parking) {
                      <div class="storageItem" (click)="performRecentSearch(item)">
                        <div class="icons">
                          <i class="ico-parking ico-material input_icon" aria-hidden="true"></i>
                          <span class="visuallyhidden" i18n="@@searchAirportParking">Parking</span>
                        </div>
                        <div class="details">
                          @if (item.searchArgs.locationCode) {
                            <span
                              class="Title"
                              tabindex="0"
                              (keydown.enter)="performRecentSearch(item)"
                              role="button"
                              id="recent_search_{{ i }}"
                            >
                              {{
                                item.searchArgs.airportFullName
                                  ? item.searchArgs.airportFullName +
                                    ' (' +
                                    item.searchArgs.locationCode +
                                    ')'
                                  : (item.searchArgs.locationCode | airportIata | async)
                              }}
                            </span>
                          }
                          <span class="Date">
                            {{ item.searchArgs.arrivalDatetime | sabsDate: 1 }} -
                            {{ item.searchArgs.departDatetime | sabsDate: 1 }}
                          </span>
                          <app-recent-search-travellers
                            [travellers]="item.travellers"
                          ></app-recent-search-travellers>
                        </div>
                        <div
                          class="recent-search-remove"
                          (click)="removeRecentSearchItem(item, $event)"
                          (keydown.enter)="removeRecentSearchItem(item, $event)"
                          tabindex="0"
                          role="button"
                          aria-label="Remove parking search"
                        >
                          <i class="ico-trash" aria-hidden="true"></i>
                        </div>
                      </div>
                    }
                    <!-- LOUNGE -->
                    @if (item.serviceType === serviceType.Lounge) {
                      <div class="storageItem" (click)="performRecentSearch(item)">
                        <div class="icons">
                          <i class="ico-lounge ico-material input_icon" aria-hidden="true"></i>
                          <span class="visuallyhidden" i18n="@@mbiLounge">Lounge</span>
                        </div>
                        <div class="details">
                          @if (item.searchArgs.locationCode) {
                            <span
                              class="Title"
                              tabindex="0"
                              (keydown.enter)="performRecentSearch(item)"
                              role="button"
                              id="recent_search_{{ i }}"
                            >
                              {{
                                item.searchArgs.airportFullName
                                  ? item.searchArgs.airportFullName +
                                    ' (' +
                                    item.searchArgs.locationCode +
                                    ')'
                                  : (item.searchArgs.locationCode | airportIata | async)
                              }}
                            </span>
                          }
                          <span class="Date">
                            {{ item.searchArgs.arrivalDatetime | sabsDate: 1 }}
                          </span>
                          <app-recent-search-travellers
                            [travellers]="item.travellers"
                          ></app-recent-search-travellers>
                        </div>
                        <div
                          class="recent-search-remove"
                          (click)="removeRecentSearchItem(item, $event)"
                          (keydown.enter)="removeRecentSearchItem(item, $event)"
                          tabindex="0"
                          role="button"
                          aria-label="Remove lounge search"
                        >
                          <i class="ico-trash" aria-hidden="true"></i>
                        </div>
                      </div>
                    }
                    <!-- FastTrack -->
                    @if (item.serviceType === serviceType.FastTrack) {
                      <div class="storageItem" (click)="performRecentSearch(item)">
                        <div class="icons">
                          <i class="ico-material ico-fast-track input_icon" aria-hidden="true"></i>
                          <span class="visuallyhidden">Fast Track</span>
                        </div>
                        <div class="details">
                          @if (item.searchArgs.locationCode) {
                            <span
                              class="Title"
                              tabindex="0"
                              (keydown.enter)="performRecentSearch(item)"
                              role="button"
                              id="recent_search_{{ i }}"
                            >
                              {{
                                item.searchArgs.airportFullName
                                  ? item.searchArgs.airportFullName +
                                    ' (' +
                                    item.searchArgs.locationCode +
                                    ')'
                                  : (item.searchArgs.locationCode | airportIata | async)
                              }}
                            </span>
                          }
                          <span class="Date">
                            {{ item.searchArgs.arrivalDatetime | sabsDate: 1 }}
                          </span>
                          <app-recent-search-travellers
                            [travellers]="item.travellers"
                          ></app-recent-search-travellers>
                        </div>
                        <div
                          class="recent-search-remove"
                          (click)="removeRecentSearchItem(item, $event)"
                          (keydown.enter)="removeRecentSearchItem(item, $event)"
                          tabindex="0"
                          role="button"
                          aria-label="Remove fast track search"
                        >
                          <i class="ico-trash" aria-hidden="true"></i>
                        </div>
                      </div>
                    }
                    <!-- TAXI -->
                    @if (item.serviceType === serviceType.Cab) {
                      <div class="storageItem" (click)="performRecentSearch(item)">
                        <div class="icons">
                          <i class="ico-taxi input_icon" aria-hidden="true"></i>
                          <span class="visuallyhidden" i18n="@@searchTaxi">Taxi</span>
                        </div>
                        <div class="details">
                          <span
                            class="Title"
                            tabindex="0"
                            (keydown.enter)="performRecentSearch(item)"
                            role="button"
                            id="recent_search_{{ i }}"
                          >
                            @if (item.searchArgs?.fromLocation; as fromLocation) {
                              <div>
                                @if (fromLocation.buildingName || fromLocation.streetAndNumber) {
                                  {{ fromLocation.buildingName }}
                                  {{ fromLocation.streetAndNumber }},
                                }
                                {{ fromLocation.town }}
                                {{ fromLocation.countryCode }}
                                @if (!fromLocation.buildingName && !fromLocation.streetAndNumber) {
                                  {{ fromLocation.postcode }},
                                }
                                -
                              </div>
                            }
                            @if (item.searchArgs?.toLocation; as toLocation) {
                              <div>
                                @if (toLocation.buildingName || toLocation.streetAndNumber) {
                                  {{ toLocation.buildingName }} {{ toLocation.streetAndNumber }},
                                }
                                {{ toLocation.town }}
                                {{ toLocation.countryCode }}
                                @if (!toLocation.buildingName && !toLocation.streetAndNumber) {
                                  {{ toLocation.postcode }},
                                }
                              </div>
                            }
                          </span>
                          <span class="Date">
                            {{ item.searchArgs.departs | sabsDate: 1 }}
                          </span>
                          <app-recent-search-travellers
                            [travellers]="item.travellers"
                          ></app-recent-search-travellers>
                        </div>
                        <div
                          class="recent-search-remove"
                          (click)="removeRecentSearchItem(item, $event)"
                          (keydown.enter)="removeRecentSearchItem(item, $event)"
                          tabindex="0"
                          role="button"
                          aria-label="Remove taxi search"
                        >
                          <i class="ico-trash" aria-hidden="true"></i>
                        </div>
                      </div>
                    }
                    <!-- EUROSTAR -->
                    @if (item.serviceType === serviceType.Eurostar) {
                      <div class="storageItem" (click)="performRecentSearch(item)">
                        <div class="icons">
                          <i class="custom_icon-eurostar input_icon" aria-hidden="true"></i>
                          <span class="visuallyhidden" i18n="@@eurostar">Eurostar</span>
                        </div>
                        <div class="details">
                          <span
                            class="Title"
                            tabindex="0"
                            (keydown.enter)="performRecentSearch(item)"
                            role="button"
                            id="recent_search_{{ i }}"
                          >
                            {{ item.searchArgs.departLocation?.destination }} -
                            {{ item.searchArgs.arriveLocation?.destination }}</span
                          >
                          <span class="Date">
                            {{ item.searchArgs.outboundDate | sabsDate: 1 }}
                            {{
                              item.searchArgs.returnDate
                                ? ' - ' + (item.searchArgs.returnDate | sabsDate: 1)
                                : ''
                            }}
                          </span>
                          <app-recent-search-travellers
                            [travellers]="item.travellers"
                          ></app-recent-search-travellers>
                        </div>
                        <div
                          class="recent-search-remove"
                          (click)="removeRecentSearchItem(item, $event)"
                          (keydown.enter)="removeRecentSearchItem(item, $event)"
                          tabindex="0"
                          role="button"
                          aria-label="Remove Eurostar search"
                        >
                          <i class="ico-trash" aria-hidden="true"></i>
                        </div>
                      </div>
                    }
                  } @else {
                    <div class="recent_searches_no_recent">
                      <i class="button_spinner light-center-absolute"></i>
                    </div>
                  }
                </li>
              }
            </ul>
          } @else {
            <div class="recent_searches_no_recent">
              <i class="button_spinner light-center-absolute"></i>
            </div>
          }
        </div>
      }
      @if (recentSearches.length === 0) {
        <div class="recent_searches_no_recent">
          <i class="ico-search no_recent_icon" aria-hidden="true"></i>
          <h2 class="no_recent_header" i18n="@@YouHaveNoRecentSearches">
            You have no recent searches
          </h2>
          <p class="no_recent_tag_line" i18n="@@YouHaveNoRecentSearchesMessage">
            All searches you perform will appear here so you can quickly pick up where you left off
            anytime
          </p>

          <p></p>
        </div>
      }
    } @else {
      <div class="recent_searches_no_recent">
        <i class="button_spinner light-center-absolute"></i>
      </div>
    }
  </div>
</section>
